import React, { useState } from 'react';
import { Checkbox } from './ui/checkbox';
import { Button } from './ui/button';

const AgeModal = ({ onAgree }) => {
  const [agreed, setAgreed] = useState(false);

  const handleAgree = () => {
    if (agreed) onAgree();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div className="bg-white rounded-2xl max-w-2xl w-full p-7 md:p-9 max-h-[90vh] overflow-y-auto modal-scroll shadow-2xl">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-3">
          This Adult Chat (Erotic Chat) website is for adults only.
        </h2>
        <h3 className="text-base font-semibold text-gray-700 mb-4">
          Please read the following before signing up to Flirty (the website)
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed mb-5">
          THIS WEBSITE IS FOR ADULTS ONLY AND CONTAINS SEXUALLY EXPLICIT CONTENT THAT IS NOT SUITABLE NOR INTENDED FOR MINORS AS WE OPERATE AN ADULT ENTERTAINMENT WEBSITE. PLEASE DO NOT USE OUR WEBSITE IF YOU ARE NOT OVER THE AGE OF EIGHTEEN (18) OR ARE NOT THE AGE OF MAJORITY WHERE YOU LIVE. IF YOU ARE NOT THE AGE OF MAJORITY, YOU CANNOT BE GRANTED AUTHORITY TO USE OUR WEBSITE BY A PARENT OR GUARDIAN. BY CLICKING "I AGREE" BELOW, YOU AGREE THAT YOU ARE ABOVE THE AGE OF EIGHTEEN (18) OR ARE ABOVE THE AGE OF MAJORITY WHERE YOU LIVE.
        </p>

        <div className="flex items-start gap-3 mb-6">
          <Checkbox
            id="age-agree"
            checked={agreed}
            onCheckedChange={setAgreed}
            className="mt-1 data-[state=checked]:bg-fnl-pink data-[state=checked]:border-fnl-pink"
          />
          <label htmlFor="age-agree" className="text-gray-600 text-xs leading-relaxed cursor-pointer">
            By clicking "I agree", below, you further agree that you have read our{' '}
            <span className="text-fnl-pink underline font-medium">Terms and Conditions</span>, our{' '}
            <span className="text-fnl-pink underline font-medium">Privacy Policy</span>, are familiar with their inclusions, and agree to be bound by the terms found therein.
          </label>
        </div>

        <Button
          onClick={handleAgree}
          disabled={!agreed}
          className="w-full h-14 bg-fnl-pink hover:bg-fnl-pink text-white font-bold text-lg rounded-xl btn-shadow-pink disabled:opacity-50 disabled:cursor-not-allowed"
        >
          I Agree
        </Button>
      </div>
    </div>
  );
};

export default AgeModal;
